import { AuthActions } from 'src/redux/actions/constant';

const {
  POST_RESET_PASSWORD_REQUEST,
  POST_RESET_PASSWORD_SUCCESS,
  POST_RESET_PASSWORD_FAILURE,
  POST_RESET_PASSWORD_LOADING,
  POST_RESET_PASSWORD_RESET,
} = AuthActions;

const intialState: object = {
  response: null,
  loading: false,
  isSuccess: null,
};

export const postPasswordResetReducer = (state = intialState, action: any) => {
  switch (action.type) {
    case POST_RESET_PASSWORD_SUCCESS: {
      return {
        ...state,
        response: action.payload,
        loading: false,
        isSuccess: true,
      };
    }
    case POST_RESET_PASSWORD_FAILURE: {
      return {
        ...state,
        response: action.payload,
        loading: false,
        isSuccess: false,
      };
    }

    case POST_RESET_PASSWORD_LOADING:
      return {
        ...state,
        loading: true,
      };
    case POST_RESET_PASSWORD_RESET:
      return {
        ...state,
        response: null,
        loading: false,
        isSuccess: null,
      };
    default:
      return state;
  }
};
